import { useEffect, useState } from 'react'
import { isMobile } from 'react-device-detect'
import { Link, useNavigate } from 'react-router-dom'
import { ReviewBoardsItem } from '../../@types/home'
import { getReviewBoards } from '../../api/home'
import { getReviewDetail } from '../../api/product'
import { plusComma } from '../../js/script'
import { imgURL } from '../Footer'
import { useAppContext } from '../provider/AppProvider'
import { AFWebLinkType, RNPostMessage } from '../../js/postMessage'

export function MemberReviewItem({ el }: any) {
  const { isAppView } = useAppContext()
  const navigate = useNavigate()

  const [productItem, setProductItem] = useState<ReviewBoardsItem>()
  const [reviewDetail, setReviewDetail] = useState<string>('')
  const [reviewDetails, setReviewDetails] = useState<any>()
  const starCountArray: number[] = [0, 0, 0, 0, 0]
  useEffect(() => {
    getReviewBoards()
      .then((res) => {
        res.data.items.map((element: any) => {
          element.reviews.map((ele: any) => {
            if (ele.reviewNo === el.reviewNo) {
              setProductItem(element)
            }
          })
        })
      })
      .catch((err) => console.log(err))
  }, [el])

  useEffect(() => {
    if (productItem) {
      getReviewDetail(String(productItem.productNo), el.reviewNo)
        .then((res) => {
          setReviewDetail(res.data.registerYmdt)
          setReviewDetails(res.data)
        })
        .catch((err) => console.log(err))
    }
  }, [productItem])

  return (
    <li>
      <div className='member_review_wrap'>
        <div className='contents_wrap'>
          {el?.images[0] && (
            <div className='item_img'>
              <div
                onClick={() => {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.moveToLink, {
                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${el.productInfo.no}`,
                    })
                  } else {
                    navigate(`/product/${el.productInfo.no}`)
                  }
                }}
                style={{
                  display: 'block',
                  width: isMobile ? '90px' : '100px',
                  height: isMobile ? '90px' : '100px',
                  backgroundImage: `url(${el?.images[0]})`,
                  backgroundPosition: 'center',
                  backgroundSize: 'cover',
                  boxShadow: '0px 0px 0px 1px rgba(0, 0, 0, 0.05) inset',
                  borderRadius: '6px',
                  overflow: 'hidden',
                }}
              ></div>
            </div>
          )}
          <div className='review_txt_wrap'>
            <div className='star_rating'>
              <div>
                {starCountArray.map((element: number, idx: number): JSX.Element => {
                  if (idx + 1 <= Math.ceil(el.reviewRate)) {
                    if (el.reviewRate - idx <= 0.5) {
                      return <img src={`${imgURL}/star_half_off.svg`} alt='별점' key={idx} />
                    } else {
                      return <img src={`${imgURL}/star.svg`} alt='별점' key={idx} />
                    }
                  } else {
                    return <img src={`${imgURL}/star_off.svg`} alt='별점' key={idx} />
                  }
                })}
              </div>
              <span>{el?.reviewRate}</span>
            </div>
            <div className='member_review_txt'>
              <div
                onClick={() => {
                  if (isAppView) {
                    RNPostMessage(AFWebLinkType.moveToLink, {
                      url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${el.productInfo.no}`,
                    })
                  } else {
                    navigate(`/product/${el.productInfo.no}`)
                  }
                }}
              >
                {el?.content}
              </div>
            </div>
            <div className='member_info'>
              <p className='name'>{reviewDetails?.name}</p>
              <p className='date'>
                {reviewDetail?.split(' ', 1).join('').replaceAll('-', '. ').replaceAll('. 0', '. ')}
              </p>
            </div>
          </div>
        </div>
        <div className='item_txt_wrap'>
          <div
            className='item_product'
            onClick={() => {
              if (isAppView) {
                RNPostMessage(AFWebLinkType.moveToLink, {
                  url: `aboutfishing://aboutfishing.com/?page=webview&url=${process.env.REACT_APP_SHOP_URL}/product/${el.productInfo.no}`,
                })
              } else {
                navigate(`/product/${el.productInfo.no}`)
              }
            }}
          >
            <div className='item_title'>{el?.productInfo?.name}</div>
            <div className='item_sale'>
              <span className='percent'>
                {Math.floor(
                  (((productItem?.salePrice || 0) - (productItem?.appliedImmediateDiscountPrice || 0)) /
                    (productItem?.salePrice || 0)) *
                    100
                )}
                %
              </span>
              <span className='price'>{plusComma(productItem?.appliedImmediateDiscountPrice)}원</span>
            </div>
          </div>
        </div>
      </div>
    </li>
  )
}
